enum CertificateStatus {
  ISSUED = 1,
  REVOKED = 2,
  AWAITING_ISSUANCE = 3,
  AWAITING_VERIFICATION = 4,
  AWAITING_VALIDATION = 5,
  CANCELED = 6,
}

export default CertificateStatus;